import { LoadingButton } from '@mui/lab';
import { Box, TextField, Typography } from '@mui/material';
import hexToRgba from 'hex-to-rgba';
import { useState } from 'react';

import logo from '../../assets/imgs/logo.png';
import { useApi } from '../../shared/hooks/use-api.hook';
import { body2 } from '../../shared/theme/text.styles';
import { loadStates, MailUrls } from '../../shared/utils/api.utils';

import MaxWidthContainer from '../shared/max-width-containe/max-width-container.component';

import { useFooterStyles } from './footer.styles';

const defaultMailState = {
  name: '',
  email: '',
  message: '',
};

const Footer = () => {
  const classes = useFooterStyles();
  const [mail, setMail] = useState(defaultMailState);

  const [addMail, loadState] = useApi({ url: MailUrls.addMail });

  const handleChange = (evt) => {
    const { id, value } = evt.target;

    setMail({ ...mail, [id]: value });
  };

  const handleSubmit = async (evt) => {
    evt.preventDefault();

    try {
      await addMail(mail);
      const form = document.getElementById('message-form');
      form.reset();
    } catch (error) {}
  };

  return (
    <Box component='footer' className={classes.footerRoot}>
      <Box className={`${classes.whiteBall} left`} />
      <Box className={`${classes.whiteBall} right`} />
      <MaxWidthContainer>
        <Box display='flex' justifyContent='center' columnGap={'240px'} zIndex={6}>
          <Box className={classes.addressAndBrand}>
            <Box display='flex' alignItems='center'>
              <Box className={classes.logoWrapper}>
                <img src={logo} alt='graphshala' className='logo' />
              </Box>
            </Box>
            <Typography className={classes.address}>
              9, Crooked Lane <br /> Esplanade, Chowringhee North,
              <br /> Bow Barracks, Kolkata, West Bengal 700069
            </Typography>
          </Box>
          <Box
            className={classes.footerForm}
            component='form'
            onSubmit={handleSubmit}
            id='message-form'
          >
            <Typography fontSize={'24px'}>Contact Us</Typography>
            <Box display='flex' justifyContent='space-between' padding='20px 0'>
              <TextField
                id='name'
                variant='outlined'
                label='Name'
                focused
                required
                onChange={handleChange}
              />
              <TextField
                variant='outlined'
                label='Email'
                id='email'
                focused
                onChange={handleChange}
                required
              />
            </Box>
            <TextField
              fullWidth
              focused
              sx={{
                marginBottom: '20px',
              }}
              variant='outlined'
              label='Message'
              id='message'
              required
              onChange={handleChange}
            />
            <LoadingButton
              loading={loadState === loadStates.loading}
              variant='contained'
              type='submit'
            >
              Send Message
            </LoadingButton>
          </Box>
        </Box>
      </MaxWidthContainer>
    </Box>
  );
};

export default Footer;
